export const enum EmbeddedEvent {
  LOAD = 'loaded',
  SIGN = 'signed',
  RESIZE = 'resized',
}

export const EMBEDDED_RESIZE_HEIGHT_DIFF = 48;
